<template>
  <div class="product-options block" v-if="categoriesHiddenWhenDisabled == 0 || groupedCategory.active === 1">
    <div class="product-options__icon" :class="`product-options__icon--${groupedCategory.id}`" v-bind:style="{ 'background-image': 'url('+ headerBackground + ')' }">
      <icon :iconID="groupedCategory.id" />
    </div>

    <div class="product-options__toggle" v-if="categoriesHiddenWhenDisabled == 0 && !groupedCategory.required  ">
      <toggle-button
        :color=switchColor
        :labels="{ checked: 'AAN', unchecked: 'UIT' }"
        :width="72"
        :height="32"
        :font-size="12"
        :value="groupedCategory.active === 1"
        @change="OnChangeOptionGroup"
      />
    </div>
    <div
      class="product-options__group"
      v-for="category in groupedCategory.children"
      :key="category.id"
      :class="{ 'product-options__group--disabled': groupedCategory.active !== 1 }"
    >
      <h3 class="product-options__title">{{ category.title }}</h3>
      <div class="product-options__description" v-html="category.description"></div>

      <div class="product-options__categories">
        <div class="option-category">
          <div
            class="option"
            v-for="(option, i) in category.products"
            :key="i"
            :class="{
              'product-options--disabled': checkDisabled(option),
              'hidden': isHidden(option),
            }"
          >
            <label>
              <div class="option__input">
                <input
                  type="radio"
                  @click="trySelectOption($event, option, category.id, category)"
                  :name="`option_${category.id}`"
                  :disabled=false
                  :value="1"
                  v-model="option.active"
                  v-if="category.selector === 'single'"
                  key="i"
                />
                <input
                  type="checkbox"
                  @click="trySelectOption($event, option, category.id, category)"
                  :name="`option_${category.id}`"
                  :disabled="option.type === 'BASIS'"
                  :checked="option.active"
                  v-model="option.active"
                  v-else
                />
                <span></span>
              </div>
              <div class="option__content">
                <h5 class="option__title">{{ option.product_name }}</h5>
                <div class="option__icon" v-if="option.product_description">
                  <icon :icon="`info-circle.svg`" />
                  <div class="block option__description">
                    <div class="option__header-container">
                      <icon class="description__icon" :icon="`info-circle.svg`" />
                      <h1 class="description__title">
                        {{ option.product_name }}
                      </h1>
                    </div>
                    <p class="description__body" v-html="option.product_description"></p>
                  </div>
                </div>
              </div>
            </label>
            <div v-if="option.product_interval === 'EENMALIG'">
              <div class="option__price" v-if="option.product_price !== 0">
                {{ option.product_price | toDisplayPrice }}
                <div class="option__price-interval">
                  {{ option.product_interval }}
                </div>
              </div>
              <div class="option__price" v-else-if="option.initialActive">INBEGREPEN</div>
              <div class="option__price" v-else>GRATIS</div>
            </div>
            <div v-else>
              <div class="option__price" v-if="option.product_price !== 0 && category.selector !== 'multiple'">
                {{ option.extra_price | toDisplayPriceDelta }} / mnd
              </div>
              <div class="option__price" v-else-if="option.product_price !== 0">
                {{ option.product_price | toDisplayPriceDelta }}
                / mnd
              </div>
              <div class="option__price" v-else-if="option.initialActive">INBEGREPEN</div>
              <div class="option__price" v-else>GRATIS</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleButton from '../../node_modules/vue-js-toggle-button/src/Button' // Import directly from node_modules because of css issues.
import swal from 'sweetalert'
import State from '../state'
import productHelpers from '../helpers/productHelpers'
import Icon from '../components/icon'
import priceFilters from '../filters/priceFilters'
import priceHelpers from '../helpers/priceHelpers'

export default {
  computed: {
    switchColor: function () {
      return getComputedStyle(document.documentElement).getPropertyValue('--switch-color')
    },
    assetPath () {
      let path
      /* eslint-disable no-undef */
      if (typeof PlinqApiUrlData !== 'undefined') {
        path = PlinqApiUrlData.VUE_APP_ASSETS_PATH
        /* eslint-enable no-undef */
      } else {
        path = process.env.VUE_APP_ASSETS_PATH
      }

      return path
    },
    headerBackground: function () {
      const background = process.env.VUE_APP_DETAILS_FORM_HEADER_IMAGE
      if (background === undefined || background === null) return null
      return "'" + this.assetPath + background + "'"
    },
    categoriesHiddenWhenDisabled: function () {
      return process.env.VUE_APP_PRESET_CATEGORIES_HIDDEN_WHEN_DISABLED
    }
  },
  components: {
    ToggleButton,
    Icon
  },
  props: {
    groupedCategory: Object
  },
  methods: {
    checkDisabled (product) {
      return productHelpers.checkDisabled(product)
    },
    isHidden (product) {
      const shouldBeHidden = product.extra_price_base === null
      if (shouldBeHidden) {
        product.active = 0
      }
      return shouldBeHidden
    },
    selectOption (productID, categoryID) {
      State.selection.categories.map(category => {
        if (category.id === categoryID && category.selector !== 'multiple') {
          category.products = category.products.map(product => {
            if (
              product.product_id === productID &&
              !productHelpers.checkDisabled(product)
            ) {
              product.active = 1
            } else {
              product.active = 0
            }

            return product
          })
        }

        return category
      })

      State.selection.categories = priceHelpers.addExtraPriceProperty(
        State.selection.categories
      )
    },
    OnChangeOptionGroup () {
      this.groupedCategory.children.forEach(category => {
        category.active = category.active === 0 ? 1 : 0
        category.products.forEach(p => {
          if (category.active === 0) {
            p.active = 0
          } else {
            if (p.type === 'BASIS') {
              p.active = 1
            }
          }
        })
      })
    },
    checkNotNeeded (product, category) {
      return productHelpers.checkNotNeeded(product, category)
    },
    checkDependantsEnabled (option) {
      return productHelpers.checkDependantsEnabled(option)
    },
    trySelectOption (event, option, categoryID, category) {
      console.log('trySelectOption')
      if (!this.checkDisabled(option) && !this.checkNotNeeded(option, category) && !this.checkDependantsEnabled(option)) {
        console.log('just change')
        this.selectOption(option.product_id, categoryID)
      } else {
        console.log('check before change')
        const requirements = productHelpers.findRequired(option)
        const notCombinedWith = productHelpers.findNotCombinedWith(option)
        const notCombinedWithBASIS = productHelpers.findNotCombinedWithBASIS(option)
        const notNeeded = productHelpers.findAllWithSameRequirementsDeactivated(option, category)
        const enabledDependants = productHelpers.findAllEnabledDependants(option)

        if (requirements.length > 0) {
          const productNames = requirements.map(p => p.product_name).join(' en ')
          swal({
            title: 'Let op',
            text: `Om deze optie te activeren moet ${productNames} ook geactiveerd zijn.\n\nWil je dit doen?`,
            icon: 'warning',
            buttons: {
              cancel: 'Nee',
              yes: {
                text: 'Ja',
                value: true
              }
            }
          }).then((activate) => {
            if (activate) {
              requirements.forEach(r => (r.active = 1))
              option.active = 1
            }
          })
        } else if (notCombinedWith.length > 0) {
          const productNames = notCombinedWith.map(p => p.product_name).join(' en ')
          this.selectOption(option.product_id, categoryID)
          swal({
            title: 'Let op',
            text: `Deze optie kan niet samen met ${productNames}.\n\nWil je die deactiveren?`,
            icon: 'warning',
            buttons: {
              cancel: 'Nee',
              yes: {
                text: 'Ja',
                value: true
              }
            }
          }).then((deactivate) => {
            if (deactivate) {
              notCombinedWith.forEach(r => (r.active = 0))
              option.active = 1
            }
          })
        } else if (notCombinedWithBASIS.length > 0) {
          const productNames = notCombinedWithBASIS.map(p => p.product_name).join(' en ')
          var currentSelectedSingle = null
          State.selection.categories.map(category => {
            if (category.id === categoryID && category.selector !== 'multiple') {
              category.products.map(product => {
                if (
                  product.product_id !== option.product_id &&
                  product.active === 1
                ) {
                  currentSelectedSingle = product
                }
              })
            }
          })
          currentSelectedSingle.active = 0
          swal({
            title: 'Let op',
            text: `${productNames} is al van toepassing.\n\nWil je ${option.product_name} alsnog activeren?`,
            icon: 'warning',
            buttons: {
              cancel: 'Nee',
              yes: {
                text: 'Ja',
                value: true
              }
            }
          }).then((activate) => {
            if (activate) {
              this.selectOption(option.product_id, categoryID)
            } else {
              this.selectOption(currentSelectedSingle.product_id, categoryID)
              currentSelectedSingle.active = 1
            }
          }).finally(() => {
            this.$forceUpdate()
          })
        } else if (notNeeded.length > 0) {
          const productNames = notNeeded.map(p => p.product_name).join(' en ')
          swal({
            title: 'Let op',
            text: `Als u deze optie deactiveert is ${productNames} niet meer nodig.\n\nWil je die ook deactiveren?`,
            icon: 'warning',
            buttons: {
              cancel: 'Nee',
              yes: {
                text: 'Ja',
                value: true
              }
            }
          }).then((deactivate) => {
            if (deactivate) {
              notNeeded.forEach(r => (r.active = 0))
              option.active = 0
            }
          })
          option.active = 0
        } else if (enabledDependants.length > 0) {
          const productNames = enabledDependants.map(p => p.product_name).join(' en ')
          swal({
            title: 'Let op',
            text: `Als u deze optie deactiveert is ${productNames} niet meer mogelijk.\n\nWil je die ook deactiveren?`,
            icon: 'warning',
            buttons: {
              cancel: 'Annuleren',
              yes: {
                text: 'Beide deactiveren',
                value: true
              }
            }
          }).then((deactivate) => {
            if (deactivate) {
              enabledDependants.forEach(r => (r.active = 0))
              option.active = 0
            } else {
              option.active = 1
            }
          })
        }
      }
      const activeWhen = productHelpers.findAllActiveWhen(option)

      if (activeWhen.length > 0) {
        activeWhen.forEach(r => (r.active = !option.active))
      }
    }
  },
  filters: {
    toDisplayPrice: priceFilters.toDisplayPrice,
    toDisplayPriceDelta: priceFilters.toDisplayPriceDelta
  }
}
</script>

<!-- seperate style for css variable as this cannot be expoed to button-switch in scoped style -->
<style lang="scss">
:root {
  --switch-color: #{color(2)};
}

</style>

<style scoped lang="scss">

.hidden {
  display: none !important;
}

div.product-options {
  position: relative;
  margin-bottom: 50px;
  padding: 30px;
}

.product-options__group--disabled {
  opacity: 0.2;
  pointer-events: none;
}

// .product-options--disabled {
//   opacity: 0.2;
// }

.product-options__group:not(:last-child) {
  margin-bottom: 50px;
}

.product-options__icon {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  border-radius: 100%;
}

.product-options__icon--100 {
  background-color: color('internet');
}

.product-options__icon--200 {
  background-color: color('telefonie');
}

.product-options__icon--300 {
  background-color: color('televisie');
}

.product-options__icon--400 {
  background-color: color('apparatuur');
}

.product-options__icon--500 {
  background-color: color('intallatie');
}

.product-options__icon--600 {
  background-color: color('extra');
}

.product-options__icon--700 {
  background-color: color('extra');
}

.product-options__icon--900 {
  background-color: color('extra');
}

.product-options__toggle {
  position: absolute;
  top: 15px;
  right: 15px;
}

.product-options__title {
  font-size: 25px;
  font-weight: 700;
  margin: 0;
  margin-bottom: 10px;
}

.product-options__description {
  font-weight: 300;
  line-height: 25px;
  padding-bottom: 10px;

  border-bottom: solid 1px $color-border;
}

.option-category__title {
  font-size: 20px;

  &::after {
    content: "";
    display: block;
    width: 250px;
    height: 1px;
    background-color: $color-border;
    margin: 15px 0;
  }
}

.option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px auto;

  label {
    display: flex;
    align-items: center;
  }
}

.option__input {
  position: relative;
  width: 35px;
  height: 100%;
  cursor: pointer;

  input {
    cursor: inherit;
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }

  input:checked ~ span {
    border-color: color('check');

    &::after {
      content: "";
      position: absolute;
      top: 2px;
      left: 2px;
      right: 2px;
      bottom: 2px;
      background-color: color('check');
      border-radius: 100%;
    }
  }

  span {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    height: 15px;
    width: 15px;
    background-color: #fff;
    border: 2px solid #4d4d4d;
    border-radius: 100%;

    cursor: inherit;
  }
}

.option__content {
  cursor: pointer;
}

.option__title {
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  display: inline-block;

  cursor: inherit;
}

.option__icon {
  display: inline-block;

  height: 2.5em;
  width: 2.5em;

  &:hover .option__description {
    display: block;
    position: absolute;
    background-color: color(2);
    z-index: 99;
    color: color(6);
    width: 100%;
    left: -10%;
    padding: 20px 50px;
  }
}

.description__icon {
  display: inline-block;
  height: auto;
  width: 2em;
  color: $text-color;
  opacity: 0.5;
}

.description__title {
  display: inline-block;
  margin: 0 10px !important;
  font-weight: bold;
  font-size: 25px;
}

.description__body {
  line-height: 1.5em;
}

.option__header-container {
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
}

.option__description {
  display: none;
}

.option__price {
  font-weight: 700;
}

.option__price-interval {
  font-size: 0.8em;
  display: inline;
}
</style>
